import { extractErrorDetails } from '../../../utils/functions/extractErrorDetails';

export const CLUB_MEMBERSHIP_REACTIVATE_TOAST_TITLE = 'Unable to Reactivate Membership';
export const DEFAULT_CLUB_MEMBERSHIP_ERROR_TOAST_MESSAGE =
  'We could not reactivate your membership right now. Please try again in a few minutes.';
export const CLUB_MEMBERSHIP_REACTIVATE_ERROR_CODE_LOG_MESSAGE =
  'Club Membership Reactivate Error Code';
export const CLUB_MEMBERSHIP_REACTIVATE_UNMAPPED_ERROR_CODE_LOG_MESSAGE =
  'Club Membership Reactivate Error Code without dedicated toast mapping';
export const CLUB_MEMBERSHIP_REACTIVATE_ERROR_LOG_MESSAGE = 'Club Membership Reactivate Error';

const CLUB_MEMBERSHIP_ERROR_TOAST_MESSAGES: Record<string, string> = {
  SHIPPING_RESTRICTED:
    'We cannot ship this box to your address. Please update your shipping information and try again.',
  OUT_OF_STOCK: 'This box is currently out of stock. Please choose another plan and try again.',
  UNKNOWN: DEFAULT_CLUB_MEMBERSHIP_ERROR_TOAST_MESSAGE,
  INSUFFICIENT_STOCK:
    'This box no longer has enough stock available. Please choose another plan and try again.',
  SOMETHING_WENT_WRONG: DEFAULT_CLUB_MEMBERSHIP_ERROR_TOAST_MESSAGE,
  BAD_REQUEST: 'We could not process your request. Please refresh the page and try again.',
  BILLING_INFO_MISSING:
    'We could not find your billing information. Please update your payment method and try again.',
  CUSTOMER_ALREADY_SUBSCRIBED: 'Your membership is already active.',
  EXPIRATION_DATE_IN_PAST:
    'Your payment method has expired. Please update your payment information and try again.',
  GIFT_CARD_ALREADY_REDEEMED: 'This gift card has already been redeemed.',
  INVALID_SHIPPING_ADDRESS:
    'Your shipping address is invalid. Please update your shipping information and try again.',
  TAX_SERVICE_OUTAGE:
    'We are having trouble calculating taxes right now. Please try again in a few minutes.',
  TRANSACTION_DECLINED:
    'Your payment was declined. Please update your payment method and try again.',
  TRANSACTION_ERROR:
    'There was an error processing your payment. Review your payment information and try again.',
};

export const getClubMembershipErrorToastMessage = (
  errorCode?: string | null,
  apiMessage?: string | null,
): string => {
  if (apiMessage?.trim()) return apiMessage.trim();
  if (!errorCode) return DEFAULT_CLUB_MEMBERSHIP_ERROR_TOAST_MESSAGE;
  return (
    CLUB_MEMBERSHIP_ERROR_TOAST_MESSAGES[errorCode] ?? DEFAULT_CLUB_MEMBERSHIP_ERROR_TOAST_MESSAGE
  );
};

export const hasMappedClubMembershipErrorToastMessage = (errorCode?: string | null): boolean =>
  Boolean(errorCode && CLUB_MEMBERSHIP_ERROR_TOAST_MESSAGES[errorCode]);

export const getErrorDetailsFromReactivateResponse = (
  response: { ok: boolean; data: unknown } | null | undefined,
): { errorCode?: string; errorMessage?: string } => {
  if (!response || response.ok) return {};
  return extractErrorDetails(response.data);
};
